var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('v-container',{staticClass:"mt-5",attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.availableItems),function(item){return _c('v-col',{key:item.text,attrs:{"cols":"12","sm":"6","md":"3"}},[_c('DashboardButton',{attrs:{"text":item.text,"icon":item.icon,"pathName":item.path}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }